import { getConfig } from "../config";
import { getVariableValue } from "../createVariable";
import { createProxy } from "./createProxy";
const extrasCache = /* @__PURE__ */ new WeakMap();
function getVariantExtras(props, languageContext, theme, defaultProps, avoidDefaultProps = false, fontFamily) {
  const conf = getConfig();
  if (extrasCache.has(props)) {
    return extrasCache.get(props);
  }
  let fonts = conf.fontsParsed;
  if (languageContext) {
    fonts = getFontsForLanguage(conf.fontsParsed, languageContext);
  }
  const next = {
    fonts,
    tokens: conf.tokensParsed,
    theme,
    get fontFamily() {
      return getVariableValue(props.fontFamily || fontFamily);
    },
    get font() {
      return fonts[this.fontFamily];
    },
    // TODO do this in splitstlye
    // we avoid passing in default props for media queries because that would confuse things like SizableText.size:
    props: avoidDefaultProps ? props : createProxy(props, {
      // handles shorthands
      get(target, key) {
        const shorthand = conf.inverseShorthands[key];
        if (shorthand && Reflect.has(target, shorthand)) {
          return Reflect.get(target, shorthand);
        }
        if (Reflect.has(target, key)) {
          return Reflect.get(target, key);
        }
        if (defaultProps) {
          if (shorthand && Reflect.has(defaultProps, shorthand)) {
            return Reflect.get(defaultProps, shorthand);
          }
          if (Reflect.has(defaultProps, key)) {
            return Reflect.get(defaultProps, key);
          }
        }
      }
    })
  };
  extrasCache.set(props, next);
  return next;
}
const fontLanguageCache = /* @__PURE__ */ new WeakMap();
function getFontsForLanguage(fonts, language) {
  if (fontLanguageCache.has(language)) {
    return fontLanguageCache.get(language);
  }
  const next = {
    ...fonts,
    ...Object.fromEntries(
      Object.entries(language).map(([name, lang]) => {
        if (lang === "default") {
          return [];
        }
        const langKey = `$${name}_${lang}`;
        return [`$${name}`, fonts[langKey]];
      })
    )
  };
  fontLanguageCache.set(language, next);
  return next;
}
export {
  getFontsForLanguage,
  getVariantExtras
};
//# sourceMappingURL=getVariantExtras.js.map
